import { Wrapper as Section } from 'components/shared/Section/styles'
import { Field } from 'components/shared/Input/styles'
import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'

export const SpecialRequestsSection = styled(Section)`
    padding-top: 24px;
    padding-bottom: 24px;

    @media ${respondAbove.xl} {
        padding-top: 40px;
        padding-bottom: 40px;
    }

    ${Field} {
        max-height: 500px;
    }
`
